import React from 'react'
import "./RemotePolicy.css";
import { Banner } from '../../Module_Exporter/Module_Exporter';
import { RemotePolicy_page_data } from '../../functions/DefaultValues';
import { Helmet } from 'react-helmet-async';

function RemotePolicy() {
  return (
    <>
    <Helmet>    
    <title>CodeSperix-Remote-Policy</title>
    </Helmet>
     <Banner  className="RemotePolicyBanner" t1={RemotePolicy_page_data.main_heading.t1} text={RemotePolicy_page_data.main_heading_sub_headline} t2={RemotePolicy_page_data.main_heading.t2} w={RemotePolicy_page_data.bar.w}  />
    <section id='RemotePolicy_container'>
      {
        RemotePolicy_page_data.detial_rules
      }
    </section>
    </>
  )
}

export default RemotePolicy;